/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
/* eslint-disable max-len */
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastController } from '@ionic/angular';
import { AuthService } from './auth.service';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})


export class LedgerService {
  ledger;
  unsub1;
  balance;
  currentUser = this.authService.currentUser;
  ledgerUpdate: BehaviorSubject<any> = new BehaviorSubject(undefined); // Save logged in user data
  videoList = [];
  constructor(
    public firestore: AngularFirestore,
    public toastController: ToastController,
    public authService: AuthService
  ) {
    this.unsub1 = this.authService.currentAccount.subscribe(async (user) => {
      if (user) {
        this.currentUser = user;
        this.getUserLedger(user.id);
      }
    });
    window.addEventListener('ledger-update', (event: any) => {
      this.addUserLedger(event.detail);
    });
  }

  checkPaymentExists(pId) {
    return new Promise(async (resolve, reject) => {
      const q = this.firestore.collection('ledger', ref => ref.where('payment_id', '==', pId).limit(1));
      const documentSnapshots = await q.get().toPromise();
      console.log(documentSnapshots.size);
      if (documentSnapshots.size > 0) {
        documentSnapshots.forEach(async docRef => {
          const item = docRef.data();
          (item as any).id = docRef.id;
          console.log(item);
          if (item && (item as any)?.value && (item as any)?.user) {
            return resolve(true);
          } else {
            return resolve(false);
          }
        });
      } else {
        return resolve(false);
      }
    });
  }

  getUserLedger(id) {
    return new Promise(async (resolve, reject) => {
      const history = [];
      let balance = this.balance = 0;
      let earnings = 0;
      let spent = 0;
      const q = this.firestore.collection('ledger', ref => ref.where('user', '==', id).orderBy('createdAt', 'desc'));
      const documentSnapshots = await q.get().toPromise();
      documentSnapshots.forEach(async docRef => {
        const item = docRef.data();
        (item as any).id = docRef.id;
        this.balance = balance = balance + (item as any).value;
        earnings = (item as any).value >= 0 ? earnings + (item as any).value : earnings;
        spent = (item as any).value < 0 ? spent + (item as any).value : spent;
        history.push(item);
      });
      if (id === this.currentUser.id) {
        console.log(id);

        this.ledger = { history, balance, earnings, spent };
        this.ledgerUpdate.next(this.ledger);
      }
      return resolve({ history, balance, earnings, spent });
    });
  }

  getVideoList() {
    const videoList = [];
    return new Promise(async (resolve, reject) => {
      const q = this.firestore.collection('coinVideos');
      const documentSnapshots = await q.get().toPromise();
      documentSnapshots.forEach(async docRef => {
        const item = docRef.data();
        (item as any).id = docRef.id;
        videoList.push(item);
      console.log('---aa----', videoList);
      });
      this.videoList = videoList;
      console.log('---aa----', this.videoList);
      return resolve(videoList);
    });
  }

  addUserLedger(data: any) {
    if (this.balance + data.value >= 0) {
      data.createdAt = new Date();
      return new Promise((resolve, reject) => {
        this.firestore.collection('ledger').add({
          ...data
        }).then((res) => {
          if (data.user === this.currentUser.id) {
            this.presentToast(`${data.value} ${data.value === 1 ? 'Coin' : 'Coins'}, ${data.message}`);
            this.getUserLedger(data.user);
          }
          return resolve(res);
        }).catch((err) => reject(err));
      });
    } else {
      this.presentToast(`Not Enough Coins!`);
    }
  };

  async redeemCoupon(coupon) {
    if (coupon && coupon.trim() !== '') {
      const q = this.firestore.collection('coupons', ref => ref.where('name', '==', coupon));
      const documentSnapshots = await q.get().toPromise();
      if (documentSnapshots.size === 0) {
        this.presentToast(`No ${coupon} Coupon Exists!`);
      }
      documentSnapshots.forEach(async docRef => {
        const item = docRef.data();
        (item as any).id = docRef.id;
        if ((item as any).users && (item as any).users?.length > 0 && (item as any).users?.includes(this.currentUser.id)) {
          this.presentToast(`Already Redeemed!`);
        } else {
          if (!(item as any).users || (item as any).users.length < 0) { (item as any).users = []; }
          (item as any).users.push(this.currentUser.id);
          this.firestore.collection('coupons').doc((item as any).id).update({ users: (item as any).users });
          this.addUserLedger({ user: this.currentUser.id, message: `You have successfully redeemed this coupon ${coupon}`, value: (item as any).value });
        }
      });
    } else {
      this.presentToast(`No Coupon Provided!`);
    }
  }
  async watchedVideo(videoId) {
    const docRef = this.firestore.collection('coinVideos').doc(videoId);
    const docSnap = await docRef.get().toPromise();

    if (docSnap.exists) {
      const item = docSnap.data();
        (item as any).id = docSnap.id;
        if ((item as any).users && (item as any).users?.length > 0 && (item as any).users?.includes(this.currentUser.id)) {
          this.presentToast(`You have Already Showed your Interest!`);
        } else {
          if (!(item as any).users || (item as any).users.length < 0) { (item as any).users = []; }
          (item as any).users.push(this.currentUser.id);
          this.firestore.collection('coinVideos').doc((item as any).id).update({ users: (item as any).users });
          this.presentToast(`You have Showed your Interest!`);
        }
    } else {
      // docSnap.data() will be undefined in this case
      console.log('No such document!');
    }
  }

  async presentToast(message) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }


}
